import { useRouter } from '@abyss/web/hooks/useRouter';

enum RedirectDuration {
    SHORT = 3000,
    MEDIUM = 4000,
    LONG = 5000
}

const RedirectService = () => {
    const { navigate } = useRouter();

    const Redirect = (url: string, duration: RedirectDuration) => {
        setTimeout(() => {
            navigate(url);
        }, duration);
    } 
    return { Redirect, RedirectDuration }
};
export { RedirectService };
